<script>
	export let text = "";
	let tooltipText;
	function adjustTooltipPosition() {
		let tooltipRect = tooltipText.getBoundingClientRect();
		console.log(tooltipRect);
		const viewportWidth = window.innerWidth;

		if (tooltipRect.left < 0) {
			tooltipText.style.width = `125px`;
		} else if (tooltipRect.right > viewportWidth) {
			tooltipText.style.left = `${viewportWidth - tooltipRect.right - 10}px`;
		} else {
		}
	}
</script>

<div class="tooltip-container" on:mouseenter={adjustTooltipPosition}>
	<slot></slot>
	<div bind:this={tooltipText} class="tooltip-text">{text}</div>
</div>

<style>
	.tooltip-container {
		position: relative;
		display: inline-block;
		font-weight: bold;
		text-decoration: underline;
		cursor: pointer;
		transition: color 0.3s; /* Smooth transition for color change */
	}

	.tooltip-container:hover {
		color: #999; /* Lighter color on hover */
	}

	.tooltip-text {
		visibility: hidden; /* Initially hidden */
		width: 325px; /* Wider tooltip */
		max-width: 90vw; /* Ensure it doesn't exceed the viewport width */
		background-color: black;
		color: #fff;
		text-align: center;
		border-radius: 5px;
		padding: 5px;
		position: absolute;
		z-index: 1;
		bottom: 125%; /* Position the tooltip above the text */
		left: 50%;
		transform: translateX(-50%);
		opacity: 0; /* Initially transparent */
		transition: opacity 0.3s; /* Smooth transition */
		white-space: normal; /* Allow text to wrap */
		word-wrap: break-word;
	}

	.tooltip-container:hover .tooltip-text {
		visibility: visible; /* Make visible on hover */
		opacity: 1; /* Fully opaque on hover */
	}

	.tooltip-text::after {
		content: "";
		position: absolute;
		top: 100%; /* Position arrow at the bottom of tooltip */
		left: 50%;
		transform: translateX(-50%);
		border-width: 5px;
		border-style: solid;
		border-color: black transparent transparent transparent;
	}

	@media (max-width: 500px) {
		.tooltip-text {
			bottom: 150%; /* Adjust position for smaller screens */
		}
	}
</style>
